import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="border-t bg-gray-50/50">
      <div className="container max-w-7xl mx-auto px-4 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          {/* Brand & Legal */}
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="font-instrument text-xl font-bold">QuoteTier</span>
            </div>
            <p className="font-jetbrains text-sm text-gray-500 mb-6 max-w-xs">
              Interactive quotes that help customers upsell themselves.
            </p>
            <div className="flex flex-col gap-2 font-jetbrains text-sm text-gray-500">
              <Link to="/pricing" className="hover:text-black transition-colors font-semibold">Pricing</Link>
              <Link to="/terms" className="hover:text-black transition-colors">Terms of Service</Link>
              <Link to="/privacy" className="hover:text-black transition-colors">Privacy Policy</Link>
              <a href="mailto:info@quotetier.com" className="hover:text-black transition-colors">Contact Us</a>
            </div>
          </div>

          {/* Features */}
          <div>
            <h3 className="font-instrument font-bold mb-4">Features</h3>
            <ul className="space-y-3 font-jetbrains text-sm text-gray-600">
              <li><Link to="/features/good-better-best-pricing-software" className="hover:text-black transition-colors">Good/Better/Best Pricing</Link></li>
              <li><Link to="/features/interactive-proposals" className="hover:text-black transition-colors">Interactive Proposals</Link></li>
              <li><Link to="/features/automated-upselling-tools" className="hover:text-black transition-colors">Automated Upselling</Link></li>
              <li><Link to="/features/package-pricing-software" className="hover:text-black transition-colors">Package Pricing</Link></li>
              <li><Link to="/features/quote-tracking-analytics" className="hover:text-black transition-colors">Quote Tracking</Link></li>
            </ul>
          </div>

          {/* Templates */}
          <div>
            <h3 className="font-instrument font-bold mb-4">Templates</h3>
            <ul className="space-y-3 font-jetbrains text-sm text-gray-600">
              <li><Link to="/templates" className="hover:text-black transition-colors font-semibold">All Templates</Link></li>
              <li><Link to="/templates/tiered-hvac-proposal-template" className="hover:text-black transition-colors">HVAC Proposal</Link></li>
              <li><Link to="/templates/web-design-packages-template" className="hover:text-black transition-colors">Web Design Packages</Link></li>
              <li><Link to="/templates/construction-bid-options-template" className="hover:text-black transition-colors">Construction Bid</Link></li>
              <li><Link to="/templates/photography-pricing-packages" className="hover:text-black transition-colors">Photography Packages</Link></li>
              <li><Link to="/templates/landscaping-maintenance-packages" className="hover:text-black transition-colors">Landscaping Packages</Link></li>
            </ul>
          </div>

          {/* Compare & Industries */}
          <div>
            <h3 className="font-instrument font-bold mb-4">Resources</h3>
            <ul className="space-y-3 font-jetbrains text-sm text-gray-600 mb-8">
              <li><Link to="/roi" className="hover:text-black transition-colors font-semibold">ROI Calculator</Link></li>
              <li><Link to="/rebuild-my-quote" className="hover:text-black transition-colors font-semibold">Rebuild my quote (free)</Link></li>
              <li><Link to="/examples" className="hover:text-black transition-colors font-semibold">Quote Examples</Link></li>
              <li><Link to="/case-studies" className="hover:text-black transition-colors font-semibold">Case Studies</Link></li>
              <li><Link to="/quote-vs-estimate" className="hover:text-black transition-colors">Quote vs Estimate Guide</Link></li>
              <li><a href="/best-quoting-software-for-small-business" className="hover:text-black transition-colors">Best Quoting Software (2026)</a></li>
              <li><a href="/best-hvac-quoting-software-for-contractors" className="hover:text-black transition-colors">Best HVAC Quoting Software</a></li>
              <li><Link to="/compare/flat-rate-vs-tiered-pricing" className="hover:text-black transition-colors">Flat Rate vs Tiered</Link></li>
              <li><Link to="/compare/excel-vs-quoting-software" className="hover:text-black transition-colors">Excel vs Software</Link></li>
              <li><Link to="/compare/quotetier-vs-proposify" className="hover:text-black transition-colors">vs Proposify</Link></li>
              <li><Link to="/compare/quotetier-vs-pandadoc" className="hover:text-black transition-colors">vs PandaDoc</Link></li>
              <li><Link to="/compare/quotetier-vs-better-proposals" className="hover:text-black transition-colors">vs Better Proposals</Link></li>
            </ul>
            
            <h3 className="font-instrument font-bold mb-4">Industries</h3>
             <ul className="space-y-3 font-jetbrains text-sm text-gray-600">
              <li><Link to="/hvac-quoting-software" className="hover:text-black transition-colors">HVAC</Link></li>
              <li><Link to="/plumbing-quoting-software" className="hover:text-black transition-colors">Plumbing</Link></li>
              <li><Link to="/electrical-quoting-software" className="hover:text-black transition-colors">Electrical</Link></li>
              <li><Link to="/construction-quoting-software" className="hover:text-black transition-colors">Construction</Link></li>
              <li><Link to="/painting-quote-software" className="hover:text-black transition-colors">Painting</Link></li>
              <li><Link to="/pest-control-quoting-software" className="hover:text-black transition-colors">Pest Control</Link></li>
              <li><Link to="/landscape-quoting-software" className="hover:text-black transition-colors">Landscaping</Link></li>
              <li><Link to="/catering-quoting-software" className="hover:text-black transition-colors">Catering</Link></li>
              <li><Link to="/tree-service-quoting-software" className="hover:text-black transition-colors">Tree Service</Link></li>
              <li><Link to="/pool-construction-quoting-software" className="hover:text-black transition-colors">Pool Construction</Link></li>
              <li><Link to="/wedding-photography-quote-software" className="hover:text-black transition-colors">Wedding Photography</Link></li>
              <li><Link to="/interior-design-quoting-software" className="hover:text-black transition-colors">Interior Design</Link></li>
              <li><Link to="/auto-detailing-quoting-software" className="hover:text-black transition-colors">Auto Detailing</Link></li>
              <li><Link to="/videographer-quote-software" className="hover:text-black transition-colors">Videography</Link></li>
              <li><Link to="/small-business-quoting-software" className="hover:text-black transition-colors">Small Business</Link></li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-jetbrains text-sm text-gray-400">
            &copy; {new Date().getFullYear()} QuoteTier. All rights reserved. <span className="footer-credit">Site by <a href="https://novanorthstudio.com/?utm_source=quotetier.com&utm_medium=referral&utm_campaign=site-credit">Nova North Studio</a></span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
